import { canvasFonted, canvasLine, canvasText, canvasTextWidth } from '../../../fun-js-lib/canvas'
import Arrow from '../../../fun-js-lib/geometry/Arrow'
import Dot from '../../../fun-js-lib/geometry/Dot'
import { getJustificationSpaceWidth } from './space-width'
import { getStyledFont } from './span'

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('./line').Line[]} lines 
 * @param {Object} linesRange 
 * @param {number} linesRange.start
 * @param {number} linesRange.end
 * @param {import('../../../fun-js-lib/geometry/Rect').default} rect 
 * @param {number} lineInterval 
 */
export function drawTextLines (context, lines, linesRange, rect, lineInterval) {
  for (let lineI = linesRange.start;
    lineI < lines.length && lineI < linesRange.end;
    ++lineI) {
    const line = lines[lineI]
    let x = rect.x + line.indent
    const y = rect.y + (lineI - linesRange.start + 1) * lineInterval
    const justificationSpaceWidth = getJustificationSpaceWidth(context, line, rect.w)
    markListNodeIfNeed(line, context, x, y)
    line.wordSpans.forEach((span, spanI, spans) => {
      const spanWidth = span.width(context)
      const spaceWidth = hasSpaceAfter(spans, spanI) ? justificationSpaceWidth : 0
      drawSpan(context, spans, spanI, new Dot({ x, y }), spanWidth, spaceWidth)
      x += spanWidth + spaceWidth
    })
  }
}

/**
 * @param {import('./line').Line} line 
 * @param {CanvasRenderingContext2D} context 
 * @param {number} x 
 * @param {number} y 
 */
function markListNodeIfNeed (line, context, x, y) {
  if (line.isUnorderedList) {
    canvasText(context, '🞄', new Dot({ x: x - 35, y }))
  }
  if (line.isOrderedList) {
    let mark = line.orderNumberString + ' '
    const w = canvasTextWidth(context, mark)
    canvasText(context, mark, new Dot({ x: x - w, y }))
  }
}

/**
 * @param {import('./word-span').default[]} wordSpans 
 * @param {number} wordSpanI 
 */
function hasSpaceAfter (wordSpans, wordSpanI) {
  const wordSpan = wordSpans[wordSpanI]
  const isLast = wordSpanI === wordSpans.length - 1
  return wordSpan.hasRightSpace || 
    (!isLast && wordSpans[wordSpanI + 1].hasLeftSpace)
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('./word-span').default[]} wordSpans 
 * @param {number} wordSpanI 
 * @param {Dot} dot 
 * @param {number} wordSpanWidth 
 * @param {number} spaceWidth 
 */
function drawSpan (context, wordSpans, wordSpanI, dot, wordSpanWidth, spaceWidth) {
  const span = wordSpans[wordSpanI]
  const font = getStyledFont(span, context.font)
  canvasFonted(context, font, () => {
    canvasText(context, span.text, dot)
    underlineSpanIfNeed(context, wordSpans, wordSpanI, dot, wordSpanWidth, spaceWidth)
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('./span').Span[]} spans 
 * @param {number} spanI 
 * @param {Dot} dot 
 * @param {number} spanWidth 
 * @param {number} spaceWidth 
 */
function underlineSpanIfNeed (context, spans, spanI, dot, spanWidth, spaceWidth) {
  const span = spans[spanI]
  if (span.isUnderlined) {
    const shouldProlongUnderlineToRighterSpan =
      spanI < spans.length - 1 && spans[spanI + 1].isUnderlined
    const endX = spanWidth + 
      (shouldProlongUnderlineToRighterSpan ? spaceWidth + 1 : 0)
    canvasLine({
      context,
      arrow: new Arrow({
        start: dot,
        end: dot.moved(new Dot({ x: endX }))
      }),
      lineWidth: 3
    })
  }
}
